<template>
  <article class="card big-announcement">

    <link-to class="card__image" :to="linkUrl">
      <div class="cover" :class="{'no_images': isImages}" :style="'background-image: url('+ (this.isImages ? this.isImages : image) +');'"></div>
    </link-to>

    <page-columns class="card__columns" :reverse="false" :column_full="true">

      <template slot="first">
        <div class="card__content">
          <div class="card__meta">
            <span class="event-date">{{dateStr}}</span>
          </div>
          <h3 v-html="title"></h3>
        </div>
      </template>

      <template slot="last" >
        <div class="card description font-size-1">
          <slot></slot>

          <article-page v-if="entry && this.show" :content="entry" :back-url="`/news/#tagId${this.$route.params.category}`" back-title="Вернуться к списку новостей">
              <span v-html="entry.text"></span>
          </article-page>

          <div class="card__actions">
            <a href="#" class="text-black solid" @click.prevent="more(id,$event)">
               <span v-if="!this.show">Читать далее...</span>
               <span v-if="entry && this.show">Закрыть текст</span>
            </a>
          </div>
        </div>

      </template>

    </page-columns>

  </article>
</template>

<script>
  import NewsItemMixin from '../mixins/NewItemMixin.js'
  import ArticlePage from "../../articles/ArticlePage";

  export default {
    mixins: [NewsItemMixin],
    comments: {ArticlePage},
    data() {
      return {
        sizeImgError: '1200x500',
        isImages: false,
        show: false,
      };
    },
    methods: {
      more(id,$event) {

       // console.log(id);
       // console.log($event);
        this.show =  !this.show;
        this.$store.dispatch('content/loadSingle', { sID: 'news', ID: id });
      }
    },
    computed: {
      entry() {
        return this.$store.state.content.single.news;
      },
      linkUrl() {
        return '/news/' + this.id;
      },
    },
  }
</script>

<style lang="scss" scoped>

  .card {
    padding: 5px 0;
    margin-bottom: 10px;
    line-height: 35px;
    @media (max-width: 600px) {
      padding: 35px 0;
      margin-bottom: 10px;
    }
    @media (max-width: 400px) {
      margin-bottom: 10px;
    }

    &__image {
      display: block;
      @include ease(opacity);
      margin-bottom: 35px;
      @media (max-width: 600px) {
        margin-bottom: 15px;
      }
      &:hover {
        opacity: 0.9;
      }
      .cover {
        &.no_images {
          background: #a7a7a7 !important;
        }
        @include size(100%, 500px);
        @include background-cover();
        @media (max-width: $media_md) {
          height: 400px;
        }
        @media (max-width: 600px) {
          height: 300px;
        }
      }
    }

    &__meta {
      padding-bottom: 8px;
      font-size: 25px;
      text-transform: uppercase;
     // font-weight: bold;
      @media (max-width: 600px) {
        padding: 10px 0 25px;
      }
    }

    &.description {
       margin-bottom: 15px;

    }
    &__actions {
      text-align: left;
      margin-top: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/cards/CardNewsBig.vue